import React, { createContext, useContext, useState } from 'react';
 
const FormContext = createContext();
 
export const useForm = () => useContext(FormContext);
 
export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    businessTypeMulti: [],
     otherIndustry: "",
    locations: '',
    countries: [],
    cities: [],
    users: '',
    infrastructuretypeMulti: [],
    otherInfra: "",
    assetsMulti: [],
    otherAssets: "",
    complianceMulti: [],
   otherCompliance: "",
    securityEventMulti: [],
    otherSecurityEvent: "",
    generativeAIProductMulti: [],
    otherAI: "",
    questions: [], // Initialize questions as an empty array
    vendor: [], 
  });
  const updateFormField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: typeof value === 'string'
        ? (value.trim() !== '' ? value : null)
        : value,
    }));
  };
  

  const setQuestions = (questions) => {
    setFormData((prev) => ({ ...prev, questions }));
  };

  const updateQuestionAnswer = (index, selectedOption) => {
    setFormData((prev) => {
      const updatedQuestions = [...prev.questions];
      updatedQuestions[index].selectedOption = selectedOption || 'null';
      return { ...prev, questions: updatedQuestions };
    });
  };

  const updateQuestionComment = (index, comment) => {
    setFormData((prev) => {
      const updatedQuestions = [...prev.questions];
      updatedQuestions[index].comment = comment || "null";
      return { ...prev, questions: updatedQuestions };
    });
  };


  return (
    <FormContext.Provider value={{ formData, setFormData,
      updateFormField,
      setQuestions,
      updateQuestionAnswer,
      updateQuestionComment, }}>
      {children}
    </FormContext.Provider>
  );
};